<template>
  <Header />

  <div class="section container">
    <div class="content">
      <div class="heading">
        <h1>You Have Successfully Logged Out Of Your Account</h1>
      </div>

      <router-link to="/home" class="btn btn--primary">Log In Again</router-link>
    </div>
  </div>
</template>

<script>
import Header from '../components/Header.vue';

export default {
  components: {
    Header
  }
}
</script>
